function e({bodySiteName:e,facetName:o,facetQuestion:t,bodySiteGroup:a}){return a&&t?t.replaceAll("{{ bodySiteGroup }}",a.toLowerCase()).replaceAll("{{ bodySiteName }}",e.toLowerCase()):o}export{e as default};
